import { render, staticRenderFns } from "./SpackageLocalhostVideoEdit.vue?vue&type=template&id=cb3d80ac&"
import script from "./SpackageLocalhostVideoEdit.vue?vue&type=script&lang=js&"
export * from "./SpackageLocalhostVideoEdit.vue?vue&type=script&lang=js&"
import style0 from "./SpackageLocalhostVideoEdit.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports